export class Sierecipient {
  id: number;
  address: string;
  createAt: string;
  active: number;
}
